import { Show } from 'framework/show';
import { useServiceCatalogId } from 'domain/organization/serviceCatalog/useServiceCatalogId';
import { useServiceCatalogService } from 'domain/shared/serviceCatalog';
import ViewServiceCatalogPageMenu from 'domain/organization/serviceCatalog/Show/ViewServiceCatalogPageMenu';
import { TimelinePageLayout, TimelineLayout, Timeline } from 'framework/ui/timeline';
import { useAuthorization } from 'framework/authorization';
import useServiceKPIStructureRegistry from '../useServiceKPIStructureRegistry';
import ViewKPIStructureBreadcrumbs from './ViewKPIStructureBreadcrumbs';
import ServiceCatalogHeader from '../../shared/ServiceCatalogHeader';
import useKPIService, { KPI_STATUS, KPI_STRUCTURE_ADD } from '../useKPIService';
import { StaticFilters as Filters, ListFiltersLayout as FiltersLayout } from 'framework/list';
import KpiStatusFilter from '../shared/inputs/KPIStatusFilter';

const ViewKPIStructure = () => {
  const id = useServiceCatalogId();
  const { getById } = useServiceCatalogService();
  const { searchStructure } = useKPIService();
  const { isGranted } = useAuthorization();

  const budgetStructureRegistry = useServiceKPIStructureRegistry();

  const filters = (
    <Filters>
      <FiltersLayout>
        <KpiStatusFilter label="Status" source="status" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <Show getDataMethod={() => getById(id)}>
      <Timeline
        registries={[budgetStructureRegistry] as any}
        getDataMethod={async req => searchStructure(id, req)}
        defaultFilter={{
          status: { in: [KPI_STATUS.ACTIVE] },
        }}
      >
        <TimelinePageLayout
          title="KPI structure"
          titleVariant="h4"
          hasAddForm={isGranted(KPI_STRUCTURE_ADD)}
          breadcrumbs={<ViewKPIStructureBreadcrumbs />}
          entityHeader={<ServiceCatalogHeader />}
          menu={<ViewServiceCatalogPageMenu />}
          filter={filters}
        >
          <TimelineLayout noEntriesMessage="No entries in this KPI structure yet." />
        </TimelinePageLayout>
      </Timeline>
    </Show>
  );
};

export default ViewKPIStructure;
